export const ROUTES = {
  home: '/',
  signup: '/signup',
  page404: '/404',
  dashboard: '/dashboard',
};
